import { useMarketDataMarketSelectorItems } from '../MarketSelector/MarketData/useMarketDataMarketSelectorItems';
import type { MarketSelectorItem } from '../MarketSelector/types';

interface UseMarketDataCardMarketSelectorItemsParams {
  symbol: string | undefined;
  includeUnifiedLiquidityMarkets?: boolean;
  queryMSSRecords?: boolean;
}

/**
 * Wraps `useMarketDataMarketSelectorItems` and passes a few props that every market selector items usage will
 * want to pass within the market data card
 */
export function useMarketDataCardMarketSelectorItems({
  symbol,
  includeUnifiedLiquidityMarkets,
  queryMSSRecords,
}: UseMarketDataCardMarketSelectorItemsParams): MarketSelectorItem[] {
  return useMarketDataMarketSelectorItems({
    symbol,
    includeUnifiedLiquidityMarkets,
    queryMSSRecords,
  });
}
